<script lang="js">
export default {
  components: {},
  data() {
    return {
      lastUpdated: "February 27, 2026",
      sections: [
        {
          number: 1,
          title: "Acceptance of Terms",
          subsections: [
            {
              subtitle: "1.1 Agreement",
              content:
                "By accessing and using First City Polytechnic's website and services, you acknowledge that you have read, understood, and agree to be bound by all of the provisions in these Terms and Conditions. If you do not agree to abide by these terms, please do not use this service.",
            },
            {
              subtitle: "1.2 Modifications",
              content:
                "First City Polytechnic reserves the right to modify these Terms and Conditions at any time without prior notice. Your continued use of the website and services after such modifications constitutes your acceptance of the updated terms. We recommend reviewing this page regularly to stay informed of any changes.",
            },
          ],
        },
        {
          number: 2,
          title: "Use License and Restrictions",
          subsections: [
            {
              subtitle: "2.1 Limited License",
              content:
                "Permission is granted to temporarily download one copy of the materials (information or software) on First City Polytechnic's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.",
            },
            {
              subtitle: "2.2 Prohibited Uses",
              content:
                "Under this license you may not: modify or copy the materials; use the materials for any commercial purpose or for any public display; attempt to decompile or reverse engineer any software contained on the website; remove any copyright or other proprietary notations from the materials; or transfer the materials to another person or mirror the materials on any other server.",
            },
            {
              subtitle: "2.3 User Conduct",
              content:
                "You agree not to use the website in any manner that could damage, disable, or impair the website. Prohibited behavior includes harassing or causing distress to any person, transmitting obscene or offensive content, and disrupting the normal flow of dialogue within our website and services.",
            },
          ],
        },
        {
          number: 3,
          title: "Disclaimer of Warranties",
          subsections: [
            {
              subtitle: "3.1 As-Is Basis",
              content:
                "The materials on First City Polytechnic's website are provided on an 'as is' basis. The institution makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.",
            },
            {
              subtitle: "3.2 Accuracy of Materials",
              content:
                "The materials appearing on First City Polytechnic's website could include technical, typographical, or photographic errors. The institution does not warrant that any of the materials on its website are accurate, complete, or current. First City Polytechnic may make changes to the materials contained on its website at any time without notice.",
            },
          ],
        },
        {
          number: 4,
          title: "Limitations of Liability",
          subsections: [
            {
              subtitle: "4.1 No Liability",
              content:
                "In no event shall First City Polytechnic or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the website, even if the institution or its authorized representative has been notified orally or in writing of the possibility of such damage.",
            },
            {
              subtitle: "4.2 Third-Party Content",
              content:
                "First City Polytechnic is not responsible for any third-party content, links, or services accessible through our website. We do not endorse or assume liability for such content, and your use of third-party services is at your own risk.",
            },
          ],
        },
        {
          number: 5,
          title: "Intellectual Property Rights",
          subsections: [
            {
              subtitle: "5.1 Ownership",
              content:
                "All content on this website, including text, graphics, logos, images, software, and other materials, is the property of First City Polytechnic or its content suppliers and is protected by Nigeria and international copyright laws. You may not reproduce, distribute, or transmit any content without the institution's prior written permission.",
            },
            {
              subtitle: "5.2 Trademarks",
              content:
                "First City Polytechnic, the FCP logo, and all other trademarks, service marks, and logos used on this website are the property of First City Polytechnic. You may not use these marks without the institution's prior written consent.",
            },
          ],
        },
        {
          number: 6,
          title: "External Links and Third-Party Services",
          subsections: [
            {
              subtitle: "6.1 External Links",
              content:
                "First City Polytechnic has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by the institution of the site. Use of any such linked website is at the user's own risk.",
            },
            {
              subtitle: "6.2 Third-Party Payment Processors",
              content:
                "When you make payments through our website, you agree to the terms and conditions of the payment processor handling your transaction. First City Polytechnic is not liable for any issues arising from third-party payment services.",
            },
          ],
        },
        {
          number: 7,
          title: "Governing Law and Jurisdiction",
          subsections: [
            {
              subtitle: "7.1 Applicable Law",
              content:
                "These Terms and Conditions and all related agreements are governed by and construed in accordance with the laws of Nigeria. You irrevocably submit to the exclusive jurisdiction of the courts located in Abeokuta, Ogun State, Nigeria.",
            },
            {
              subtitle: "7.2 Dispute Resolution",
              content:
                "Any disputes arising from your use of this website or these terms shall be resolved exclusively in the courts of Abeokuta, Ogun State, Nigeria. You agree to submit to the personal jurisdiction of such courts and waive any objections to venue or inconvenient forum.",
            },
          ],
        },
        {
          number: 8,
          title: "Termination of Service",
          subsections: [
            {
              subtitle: "8.1 Right to Terminate",
              content:
                "First City Polytechnic reserves the right to terminate your access to the website and services at any time, with or without cause and with or without notice, if you violate these Terms and Conditions or engage in any conduct that we deem inappropriate or harmful.",
            },
            {
              subtitle: "8.2 Effect of Termination",
              content:
                "Upon termination, all rights and privileges granted to you under these terms shall immediately cease. You must immediately destroy any materials obtained from the website and cease all use of the website and services.",
            },
          ],
        },
        {
          number: 9,
          title: "Privacy and Data Protection",
          subsections: [
            {
              subtitle: "9.1 Privacy Policy",
              content:
                "Your use of this website is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information. Please review our Privacy Policy to understand our practices regarding data collection and usage.",
            },
          ],
        },
        {
          number: 10,
          title: "Contact Information",
          subsections: [
            {
              subtitle: "10.1 Questions or Concerns",
              content:
                "If you have any questions about these Terms and Conditions or need clarification on any provisions, please contact us at legal@firstcitypoly.edu.ng or call +234 (0) 706 337 7322. You may also visit our office at 18, Quarry Road, Ibara, Abeokuta, Ogun State, Nigeria.",
            },
          ],
        },
      ],
    };
  },
};
</script>

<template>
  <div class="terms-conditions">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container hero-content">
        <h1>Terms and Conditions</h1>
        <p class="published-date">
          Last updated and effective on {{ lastUpdated }}
        </p>
      </div>
    </div>

    <!-- Introduction Section -->
    <div class="container my-5">
      <div class="intro-section">
        <p class="intro-text">
          Welcome to First City Polytechnic. Please read these Terms and
          Conditions carefully before using our website and services. By
          accessing and using this website, you accept and agree to be bound by
          the terms and provisions of this agreement. If you do not agree to
          abide by the above, please do not use this service. These terms apply
          to all users of the website, including without limitation users who
          are browsers, vendors, customers, merchants, and/or contributors of
          content.
        </p>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container content-section">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div v-for="(section, idx) in sections" :key="idx" class="section">
            <h2 class="section-title">
              <span class="section-number">{{ section.number }}</span>
              {{ section.title }}
            </h2>

            <div
              v-for="(subsection, subIdx) in section.subsections"
              :key="subIdx"
              class="subsection"
            >
              <h3 class="subsection-title">{{ subsection.subtitle }}</h3>
              <p class="subsection-content">{{ subsection.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Note -->
    <div class="container pb-5">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div class="footer-note">
            <h5>Acceptance and Binding Agreement</h5>
            <p>
              These Terms and Conditions constitute a binding agreement between
              you and First City Polytechnic. Your use of the website signifies
              your acceptance of these terms. If you do not accept any part of
              these terms, you must discontinue your use of the website
              immediately.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.terms-conditions {
  background-color: #f5f7fa;
}

/* Hero Section */
.hero-section {
  position: relative;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  background: linear-gradient(135deg, #0e1438 0%, #1a2558 50%, #0e1438 100%);
  color: white;
  overflow: hidden;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  width: 100%;
}

.hero-section h1 {
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  letter-spacing: -1px;
}

.published-date {
  font-size: 1.1rem;
  margin-top: 15px;
  color: #ffc107;
  font-weight: 500;
}

/* Introduction Section */
.intro-section {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-left: 5px solid #ffc107;
}

.intro-text {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

/* Content Section */
.content-section {
  margin-bottom: 60px;
}

.section {
  margin-bottom: 50px;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 30px;
  color: #0e1438;
  gap: 15px;
}

.section-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%);
  color: #0e1438;
  border-radius: 50%;
  font-weight: 700;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.subsection {
  margin-bottom: 25px;
}

.subsection:last-child {
  margin-bottom: 0;
}

.subsection-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #0e1438;
  margin-bottom: 12px;
}

.subsection-content {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #555;
  margin-bottom: 0;
}

/* Footer Note */
.footer-note {
  background: linear-gradient(
    135deg,
    rgba(14, 20, 56, 0.05) 0%,
    rgba(255, 193, 7, 0.05) 100%
  );
  padding: 30px;
  border-radius: 12px;
  border: 1px solid rgba(14, 20, 56, 0.1);
}

.footer-note h5 {
  color: #0e1438;
  font-weight: 600;
  margin-bottom: 15px;
}

.footer-note p {
  color: #555;
  line-height: 1.7;
  margin-bottom: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-section h1 {
    font-size: 2rem;
  }

  .published-date {
    font-size: 0.95rem;
  }

  .intro-section,
  .section {
    padding: 25px;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .container {
    padding-left: 15px;
    padding-right: 15px;
  }

  .row {
    margin-left: 0;
    margin-right: 0;
  }

  .col-lg-10,
  .offset-lg-1 {
    max-width: 100%;
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .hero-section {
    min-height: 200px;
    margin-bottom: 30px;
  }

  .hero-section h1 {
    font-size: 1.5rem;
  }

  .published-date {
    font-size: 0.85rem;
  }

  .intro-section,
  .section {
    padding: 20px;
    margin-bottom: 25px;
  }

  .section-title {
    font-size: 1.1rem;
    flex-wrap: wrap;
  }

  .section-number {
    width: 35px;
    height: 35px;
    font-size: 0.95rem;
  }

  .subsection-title {
    font-size: 1rem;
  }

  .subsection-content {
    font-size: 0.9rem;
  }
}
</style>
